import React from "react";
import { connect } from "react-redux";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { required, noSpaces } from "utils/validation";
import { reduxFormInput, reduxFormSelect } from "components/form/ReduxForm";
import { getClauses, mergeClauses } from "redux/actions";
import Spacer from "components/layout/Spacer";

class MergeClauses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clauseOptions: [],
    };

    this.submitFn = this.submitFn.bind(this);
  }

  componentDidMount() {
    this.handleGetClauses();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clauses !== this.props.clauses) {
      const clauseOptions = this.props.clauses.map((item) => ({
        value: item._id,
        label: item.clauseName,
      }));
      this.setState({ clauseOptions });
    }
  }

  submitFn(data) {
    const ids = data.clauses.map((item) => item.value);
    mergeClauses({ ids, clauseName: data.clauseName });
  }

  handleGetClauses = () => {
    getClauses({
      limit: 500,
      order: "ASC",
      orderColumn: "clauseName",
      parent: true,
    });
  };

  render() {
    const { action, handleSubmit } = this.props;
    const isProcessing =
      action.CREATE_CLAUSE.isFetching || action.UPDATE_CLAUSE.isFetching;

    return (
      <>
        <Container>
          <Form
            className="no-border no-padding"
            onSubmit={handleSubmit(this.submitFn)}
          >
            <Row>
              <Col xs="12">
                <Field
                  isMulti
                  showLoading
                  closeMenuOnSelect={false}
                  className="form-control"
                  component={reduxFormSelect}
                  validate={[required]}
                  name="clauses"
                  type="select"
                  isLoading={action.GET_CLAUSES.isFetching}
                  options={this.state.clauseOptions}
                  placeholder="Select at least 2 clauses..."
                  label="*Clauses"
                  onFocus={this.handleGetClauses}
                />
                <Spacer size={10} />
              </Col>
            </Row>

            <Row>
              <Col xs="12">
                <Field
                  className="form-control"
                  component={reduxFormInput}
                  validate={[required, noSpaces]}
                  name="clauseName"
                  type="text"
                  placeholder="Enter new clause name"
                  label="*New Clause Name"
                />
              </Col>
            </Row>
            <Spacer size={50} />
            <Row className="justify-content-center">
              <Col className="text-center" xs="12" sm="6">
                <Button disabled={isProcessing} type="submit" variant="primary">
                  {isProcessing ? "Saving..." : "Save"}
                </Button>
              </Col>
            </Row>
          </Form>
          <Spacer size={50} />
        </Container>
      </>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    action: state.action,
    clauses: state.clause.clauses,
    initialValues: {
      clauseName:
        props.selectedClauses?.map((e) => e.clauseName).join(" ") || "",
      clauses: (props.selectedClauses || []).map((item) => ({
        value: item._id,
        label: item.clauseName,
      })),
    },
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "MergeClauses",
    enableReinitialize: true,
  })(MergeClauses)
);
